export enum SoundActionTypes {
  GET_SOUNDS_FOR_AN_ORGANIZATION_ID_PENDING = '@@sound/GET_SOUNDS_FOR_AN_ORGANIZATION_ID_PENDING',
  GET_SOUNDS_FOR_AN_ORGANIZATION_ID_SUCCESS = '@@sound/GET_SOUNDS_FOR_AN_ORGANIZATION_ID_SUCCESS',
  GET_SOUNDS_FOR_AN_ORGANIZATION_ID_ERROR = '@@sound/GET_SOUNDS_FOR_AN_ORGANIZATION_ID_ERROR'
}
